import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Modal, Button } from '@weezevent/nacre';
import UploadFileZone from './uploadFileZone';

export default function UploadFileModal({ open = false, header = null, content = null, onClose = () => {}, ...rest }) {
    const { t } = useTranslation();

    return (
        <Modal size="large" open={open} onClose={onClose} title={header} cancelButton={<Button onClick={onClose} label={t('ticket.common.action.cancel')} />}>
            {content}
            <UploadFileZone {...rest} />
        </Modal>
    );
}

UploadFileModal.propTypes = {
    organizationId: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    open: PropTypes.bool,
    eventId: PropTypes.string,
    header: PropTypes.string,
    onClose: PropTypes.func,
    onUpload: PropTypes.func,
    onError: PropTypes.func,
    getURLParams: PropTypes.func,
    getQueryParams: PropTypes.func,
    shouldUpload: PropTypes.func,
    content: PropTypes.node,
    fileTypes: PropTypes.array
};
